import React from 'react'
import styled from 'styled-components'
import { ToastContainer } from 'react-toastify'

/* CONSTANTS */
import { CLIENT_STYLINGS, size } from '../../utils/constants'
import { getBorderRadius } from '../../utils/styleUtils'

export const SearchViewWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const QuickSearchViewWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
`

export const SearchResultsWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const SearchLeftGridWrapper = styled.div`
  width: 65%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`

export const SearchGridMobileWrapper = styled.div`
  width: 100%;
`

export const EmptyDivWrapper = styled.div`
  position: sticky;
  position: -webkit-sticky; /* Safari */
  top: 0px;
  z-index: 1;
  height: 10px;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
`

export const SearchAiTextResponseWrapper = styled.div`
  padding: 5px;
  width: 30%;
  display: flex;
  align-items: flex-end;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.ASSISTANT};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.ASSISTANT_FOREGROUND};
  text-align: left;
  min-height: 170px;
  height: fit-content;

  @media (max-width: ${size.laptop}) {
    width: 100%;
    margin-bottom: 15px;
    flex-direction: column;
  }
`

export const ReadMoreWrapper = styled.div`
  align-self: center;
  display: flex;
  cursor: pointer;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  font-size: 16px;
  font-weight: 700;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
`

export const ArrowHead = styled.span`
  transition: transform 0.3s ease; /* Transition added for transform property */
  display: block;
  transform: ${({ down }) => {
    return down ? 'rotate(180deg)' : ''
  }};
  font-size: 20px;
  padding-top: 5px;
  margin-right: ${({ marginRight }) => (marginRight ? '10px' : '')};
  z-index: 99;
  margin-top: -5px;
`

export const SearchDisableInternalCaseWrapper = styled.div`
  width: 30%;

  @media (max-width: ${size.laptop}) {
    width: 100%;
  }
`

export const SearchDisableInternalCaseCta = styled.button`
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  cursor: pointer;
  font-size: 16px;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  padding: 5px 10px;

  &:hover {
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
    background-color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  }
`

export const StyledToastContainer = styled(ToastContainer)`
  .Toastify__toast {
    background: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
    border-radius: ${props => getBorderRadius(props, 'sm')};
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
    font-weight: normal;
    font-size: 12px;
    z-index: 100;
    display: inline-flex;
    max-width: ${size.mobileS};
    float: right;
    margin: 5px;
  }

  .Toastify__toast-body {
    padding: 0px 15px;
  }

  .Toastify__close-button {
    float: right;
    margin: 5px;
  }
`

export const NoResults = styled.div`
  font-size: 16px;
  font-weight: 600;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  padding: 30px 0px;
`
